export const UPLOADCARE_PUBLIC_KEY = process.env.REACT_APP_UPLOADCAREKEY;